import React, { useState, useEffect, useContext } from 'react';
import WizardContentParent from './WizardContentParent';
import WizardTreeDataSupplier from 'business/tree/WizardTreeDataSupplier';
import SearchAndList from './SearchAndList';
import SelectedScreen from './SelectedScreen';
import { isNullOrUndefined } from 'utils/Global';
import WizardService from 'business/services/WizardService';
import { ScreenInfoDTO, TreeNodeDTO } from 'business/models/Models';
import ScreenWizardContext from './ScreenWizardContext';
import Explorer, { TreeControlDefaultState, TreeControlState } from 'components/explorer';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';

const shouldRenderNode = (node) => {
  if (node.type === ETreeNodeTypes.RecycleBin) {
    return null;
  }
  return node;
};
function SelectScreenWizard({ commonTreeNodes, gSelectedNode }: any) {
  const screenWizContext = useContext(ScreenWizardContext);
  const ALL_SCREENNODE_IDS = gSelectedNode != null ? gSelectedNode.id : -2;

  let lTreeNodes = [];

  if (commonTreeNodes.length > 0) {
    lTreeNodes = [
      {
        id: -2,
        name: ETreeNodeTypes.Projects,
        type: null,
        extra: null,
        accessRightName: 'read',
        state: {
          expanded: false,
        },
      },
      ...commonTreeNodes,
    ];
  }
  const defaultTreeNode = new TreeNodeDTO();
  defaultTreeNode.id = ALL_SCREENNODE_IDS;
  const [parentNode, setparentNode] = useState<TreeNodeDTO>(defaultTreeNode);
  const [selectedScreenInfo, setSelectedScreenInfo] = useState(null);
  const [listData, setListData] = useState<ScreenInfoDTO[]>(null);
  const [treeControlState, setTreeControlState] = useState<TreeControlState>({
    ...TreeControlDefaultState,
    selectedNodes: [`node${gSelectedNode}`],
  });

  useEffect(() => {
    if (selectedScreenInfo != null) {
      screenWizContext.setWizardDataDirty(true);
    }
  }, [selectedScreenInfo]);

  useEffect(() => {
    if (isNullOrUndefined(parentNode)) {
      return;
    }
    async function fetchScreens() {
      const wizardSer: WizardService = new WizardService();
      const data = await wizardSer.getWizardScreens(
        parentNode.id,
        screenWizContext.plateType.id,
      );
      setListData(data);
    }
    fetchScreens();
  }, [parentNode, screenWizContext.plateType]);

  const globalTreeNodes = { treeNodes: [] };

  return (
    <div id='selectscreenwizard-wrapper' className="flex" style={{ height: '85%', width: '100%' }}>
      <WizardContentParent
        id="selectscreenwizard-define-location"
        style={{ flex: '6', marginLeft: '0px', paddingTop: 0 }}
        heading="Define Screen Location"
        childStyle={{ paddingBottom: '8%' }}
      >
        <Explorer
          gSelectedNode={ALL_SCREENNODE_IDS}
          setParentNode={setparentNode}
          setParentSelectedNode={undefined}
          openClicked={undefined}
          dataSupplier={WizardTreeDataSupplier}
          globalTreeNodes={globalTreeNodes}
          treeControlState={treeControlState}
          setTreeControlState={setTreeControlState}
          commonTreeNodes={lTreeNodes}
          shouldRenderNode={shouldRenderNode}
          defaultFirstSelectedNode={ETreeNodeTypes.Screens}
        />
      </WizardContentParent>
      <WizardContentParent
        id="selectscreenwizard-search-section"
        style={{ flex: '7', marginLeft: '22px', paddingTop: '0px' }}
        heading="Search Screens"
        childStyle={{ height: '88%', paddingBottom: '2%' }}
      >
        <SearchAndList
          id="selectscreenwizard-searchandlist-component"
          listData={listData}
          parentTreeId={parentNode.id}
          setData={setSelectedScreenInfo}
          placeholder="Search screen..."
        />
      </WizardContentParent>
      <WizardContentParent
        id="selectscreenwizard-selected-section"  
        style={{
          flex: '8',
          padding: '0px',
          marginLeft: '22px',
          paddingBottom: '15px',
        }}
        heading="Selected Screen(s)"
        headingStyle={{ paddingLeft: '13px' }}
        childStyle={{ height: '92%' }}
        className="screen-wizard-table wizard-select-screen-table"
      >
        <SelectedScreen selectedScreens={selectedScreenInfo} />
      </WizardContentParent>
    </div>
  );
}

export default SelectScreenWizard;
